import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { getVariantsHowText } from '../../../../util/utils';
import { formatMoney } from '../../../../util/numberUtils';

/**
 * 🧬 Molécula: OrderNoteProductListMC
 * Renderiza la tabla de productos de la orden.
 */
const OrderNoteProductListMC = React.memo(({ products, productsToShow, showMore, handleShowAll, currency, currencySymbol }) => {
  const { t } = useTranslation('InboxMC');
  if (!products) return null;
  return (
    <table className="tw-w-full tw-text-3xs tw-mt-4">
      <thead>
        <tr>
          <th className="tw-p-0 !tw-font-bold">{t('orderNote.product')}</th>
          <th className="tw-text-center tw-p-0 !tw-font-bold">{t('orderNote.quantity')}</th>
          <th className="tw-text-right tw-p-0 !tw-font-bold">{t('orderNote.total')}</th>
        </tr>
      </thead>
      <tbody>
        {products.slice(0, productsToShow).map((item, index) => (
          <tr key={`order-product-${item.id}-${index}`}>
            <td className="tw-flex tw-flex-col tw-text-xs">
              <div className="tw-mt-2">
                <span>{item.title}</span>
                {!isEmpty(item.variants) && (
                  <span className="tw-text-3xs">{getVariantsHowText(item.variants)}</span>
                )}
                {item.variant_name && (
                  <span className="tw-text-3xs">{item.variant_name}</span>
                )}
              </div>
            </td>
            <td className="tw-text-center tw-text-xs">
              <div className="tw-mt-2">{item.quantity}</div>
            </td>
            <td className="tw-text-right tw-text-xs">
              <div className="tw-mt-2">
                {currencySymbol}
                {formatMoney(item.total)} {currency}
              </div>
            </td>
          </tr>
        ))}
        {showMore && (
          <tr>
            <td colSpan={3}>
              <button
                onClick={handleShowAll}
                className="tw-bg-blue-50 tw-text-blue-700 tw-font-bold tw-text-xs tw-w-full tw-py-1 tw-rounded hover:tw-bg-blue-100"
              >
                {t('orderNote.product')}s
              </button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
});

OrderNoteProductListMC.displayName = 'OrderNoteProductListMC';
export default OrderNoteProductListMC;
